import error404 from './error404.svg'



export default {
    "error404": error404
}